module.exports = __webpack_public_path__ + "static/img/card-solution-h5.7e07068.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card-solution-h5.png
// module id = xAeg
// module chunks = 34